import {toast} from "react-toastify"
import TomClient from "../services/tomClient"

const extensionFor = (contentType) =>
    contentType.includes("spreadsheetml") || contentType.includes("excel")
        ? ".xlsx"
        : ".pdf"

const saveBlob = (blobUrl, fileName) => {
    const downloadLink = document.createElement("a")
    downloadLink.href = blobUrl
    downloadLink.download = fileName
    downloadLink.target = "_blank"
    document.body.appendChild(downloadLink)
    downloadLink.click()
    downloadLink.remove()
    globalThis.URL.revokeObjectURL(blobUrl)
}

export const downloadFileFromLink = async (hallink, name = "Dokument", body) => {
    if (!hallink?.href) {
        toast.error("Fehler: Kein Link zur Datei angegeben.")
        return
    }

    try {
        const response = await TomClient.callBackendFile(hallink, {
            body: body === undefined ? undefined : JSON.stringify(body),
            contentType: body === undefined ? undefined : "application/json",
            accept:
                "application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream",
        })

        if (!response.ok) {
            toast.error(
                `Fehler beim Laden der Datei: ${response.status} ${response.statusText}`,
            )
            console.error("Server-Antwortfehler:", await response.text())
            return
        }

        const contentType =
            response.headers.get("content-type") || "application/octet-stream"
        const blobUrl = globalThis.URL.createObjectURL(
            new Blob([await response.arrayBuffer()], {type: contentType}),
        )
        const extension = extensionFor(contentType)
        saveBlob(blobUrl, name.endsWith(extension) ? name : name + extension)
    } catch (error) {
        toast.error("Ein unbekannter Fehler ist beim Download aufgetreten.")
        console.error("Download-Fehler:", error)
    }
}
